<template>
    <div class="faq-lists">
        <el-collapse v-model="activeFaq" accordion>
            <el-collapse-item class="faq-item" v-for="(item, key) in items" :key="key" :title="item.title" :name="key">
                <div class="faq-item-content">
                    <p>{{item.content}}</p>
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>

export default {
    name: 'FaqLists',
    props: ['items'],
    data() {
        return {
            activeFaq: 0
        }
    }
}
</script>